import React, { useEffect, useState } from "react";
import "./styles.css";
import { BLOOD_GROUP_TYPES, CONTACT_TYPES } from "../../../Library/constants";
import { RippleButton } from "../../../Components/Atoms";
import { CallIcon, LocationIcon } from "../../../Assets/images/svgs";
import { getStickerDetails, getStickersByVid } from "../../../APIs";
import { useNavigate, useSearchParams } from "react-router-dom";
import PATHS from "../../../Routes/paths";
import { useToast } from "@chakra-ui/react";

const EmergencyContact = () => {

  const [ userConfig, setUserConfig ] = useState({});
  const [ selectedEmgCts, setSelectedEmgCts ] = useState({});
  const [ searchParams ] = useSearchParams();
  const navigate = useNavigate();
  const Toast = useToast();

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");

    getStickerDetails({ stickerId: searchParams.get("sid") }, (err, sticker) => {
      if (err) Toast({ isClosable: true, description: "Unable to get sticker details. Please try again later", position: "bottom", variant: "subtle", duration: 3000 });
      else setUserConfig(sticker.contact);
    });
  }, []);

  return (
    <>
      {userConfig.fn ? <div className="cs-emergency-contact-page">
        <div className="emergency-info-container">
          <div className="info-gradient-container">
            <div className="user-profile-box">
              {userConfig.settings.img ? <img src={userConfig.imgUrl} alt="" /> : userConfig.fn[0]}
            </div>
            <div className="emergency-user-details">
              <p className="emgncy-user-name cs-text-gradient">{userConfig.fn}</p>
              {(userConfig.settings.bldGrp && userConfig.bldGrp > -1) ? <p className="emgncy-user-blood-grp">Blood Group : {BLOOD_GROUP_TYPES[userConfig.bldGrp]}</p> : null}
            </div>
          </div>

          {userConfig.insurer || userConfig.insPolicyNo ? <div className="info-gradient-container policy-details">
            {userConfig.insPolicyNo ? <div className="insurance-policy-no">
              <p className="insurance-label">Medical Insurance Policy no.</p>
              <p className="insurance-detail">{userConfig.insPolicyNo}</p>
            </div> : null}
            {userConfig.insurer ? <div className="insurance-policy-provider">
              <p className="insurance-label">Insurance Provider</p>
              <p className="insurance-detail">{userConfig.insurer}</p>
            </div> : null}
          </div> : null}
        </div>

        <p className="emergency-contacts-title">Select the emergency contact to call</p>

        <div className="emergency-contacts-list">
          { userConfig.emgCts?.map(contact => (
            <div className="emergency-gradient-box">
              <RippleButton onClick={() => setSelectedEmgCts(contact)}>
                <label className="emergency-contact-input-container">
                  <input type="radio" name="emergency-contact-list" />
                  <p>{contact.nm}</p>
                </label>
              </RippleButton>
            </div>
          )) }
        </div>

        <div className="emergency-contact-btns">
          {/* update navigation path to shivendras page */}
          <RippleButton className="emergency-call-btn cs-btn-gradient" onClick={() => selectedEmgCts.mob ? navigate(`/${PATHS.CONTACT_STICKER}/${PATHS.CALL_OWNER}`, { state: { stickerId: searchParams.get("sid"), contactType: CONTACT_TYPES.CALL_EMERGENCY, custRsn: "Emergency", rsn: 6, emgCtId: selectedEmgCts.idx } }) : ""}>
            <CallIcon />
            Call {selectedEmgCts.nm || `Emergency Contact`}
          </RippleButton>

          {/* <RippleButton className="emergency-location-btn">
            <LocationIcon />
            Share location via SMS
          </RippleButton> */}
        </div>
      </div> : null}
    </>
  )
}

export default EmergencyContact
